export const PORTS_STORE_ID = 'PortsStore';
